<template>
    <UbiPanel class="block">
      <h1 v-if="isViewCreate">{{$t('prompt.creationPrompt')}}</h1>
      <h1 v-if="isViewShow">{{$t('prompt.detailsPrompt')}}</h1>
      <h1 v-if="isViewEdit">{{$t('prompt.editPrompt')}}</h1>
      <el-form data-test="prompt-form" ref="prompt" :model="localPromptData" @change="getPrompt">
        <span v-if="!isViewCreate" class="input-hidden"><el-input v-model="localPromptData.id" clearable type="hidden"></el-input></span>
        <el-form-item v-if="!isViewShow">
           <span class="font-weight-bold label-custom">
                {{$t('prompt.formTitle')}} *
           </span>
          <el-tooltip placement="top-start" :content="$t('prompt.contentTitleTooltip')">
            <em class="el-icon-question"></em>
          </el-tooltip>
          <el-input data-test="prompt-form-input-titre" v-model="localPromptData.titre" :disabled="isViewShow" clearable></el-input>
          <span class="error-donnees" v-if="isNotValidateTitre">{{$t('prompt.rulesTitre')}}</span>
        </el-form-item>
        <el-form-item v-if="!isViewShow">
           <span class="font-weight-bold label-custom">
                 {{$t('prompt.formTon')}} *
           </span>
          <el-tooltip placement="top-start" :content="$t('prompt.contentTonTooltip')">
            <em class="el-icon-question"></em>
          </el-tooltip>
          <el-select data-test="prompt-form-select-ton" v-model="localPromptData.ton" :placeholder="$t('prompt.selectedTon')"  :disabled="isViewShow" clearable>
            <el-option v-for="(item,index) in getTonsIa" :label="item" :value="item" :key="index"></el-option>
          </el-select>
          <span class="error-donnees" v-if="isNotValidateTon">{{$t('prompt.rulesTon')}}</span>
        </el-form-item>
        <el-form-item v-if="!isViewShow">
          <el-dialog
              :title="$t('prompt.availableDataList')"
              :visible.sync="dialogDataVisible"
          >
            <el-checkbox-group v-model="checkedData" data-test="prompt-form-list-data">
              <el-row>
                <el-col :span="12" v-for="donnee in getListDataInitialByJob" :key="donnee.id">
                  <el-checkbox v-if="getListDataInitialByJob.length > 0" :label="donnee.libelle" :disabled="isViewShow">{{capitalizeFirstLetter(donnee.libelle)}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-dialog>
          <span class="font-weight-bold label-custom">
                   {{$t('prompt.formDonnees')}}
          </span>
          <p class="text-donnees" data-test="prompt-form-content-univers">{{ $t(`prompt.contentUnivers${getJob}`) }}</p>
          <div class="container-donnees">
            <div>
              <el-button size="mini" type="primary" @click="showListDataAnnonceur" data-test="prompt-form-button-showListDataAnnonceur">
                {{ $t('prompt.addingAdditionalData')}}
                <el-tooltip placement="top-start" :content="$t('prompt.contentDonneesTooltip')">
                  <span><em class="el-icon-question"></em></span>
                </el-tooltip>
              </el-button>
            </div>
            <div><el-tag data-test="prompt-form-tag" class="mb-1">{{ $t('prompt.numberData') + checkedData.length }}</el-tag></div>
          </div>
          <el-divider></el-divider>
        </el-form-item>
        <div class="mb-3">
          <div class="container-button-simulate">
            <div>
              <el-button data-test="prompt-form-button-previewResult" size="mini" type="primary" @click="previewResult" v-if="!isViewShow">
                {{ $t('prompt.previewResult') }}
                <el-tooltip placement="top-start" :content="$t('prompt.contentDonneesTooltipPreview')">
                  <span><em class="el-icon-question"></em></span>
                </el-tooltip>
              </el-button>
            </div>
            <div>
              <el-button data-test="prompt-form-button-confirmValidationPrompt" size="mini" @click="confirmValidationPrompt" v-if="!isViewShow">{{$t('prompt.confirmTheCreationOfThePrompt')}}</el-button>
            </div>
          </div>
        </div>
        <el-form-item data-test="prompt-form-simulate">
          <div class="wait-simulateIA" v-if="getLoadingPromptSimulate">
            <div><p>{{ $t('posts.IA.textSpinnerIA') }}</p></div>
            <div><Stretch /></div>
          </div>
          <el-input type="textarea" autosize :placeholder="$t('prompt.textGenerateByIA')" :value="getPromptSimulate" v-if="getPromptSimulate"></el-input>
        </el-form-item>
      </el-form>
    </UbiPanel>
</template>

<style scoped>

</style>
<script>
import UbiPanel from '@/components/Panel.vue'
import { modalAddPromptMixin } from '@/mixins/modalAddPromptMixin'
import { mapGetters } from 'vuex'
import { capitalizeFirstLetter } from '@/helpers/capitalized'
import { CREATE, EDIT, VIEW } from '@/helpers/constantes/promptConstants'
import Stretch from '@/components/spinners/Stretch.vue'

export default {
  name: 'FormPrompt',
  components: { Stretch, UbiPanel },
  mixins: [modalAddPromptMixin],
  data () {
    return {
      dialogDataVisible: false,
      formSubmitted: false,
      isValid: false,
      checkedData: [],
      isHydrating: false // Flag pour éviter les boucles infinis d'hydratation
    }
  },
  computed: {
    ...mapGetters('promptLibraries', ['getTonsIa', 'getListDataInitialByJob', 'getPrompt', 'getPromptSimulate', 'getLoadingPromptSimulate']),
    ...mapGetters(['getJob', 'getSitimmoUser']),
    localPromptData () {
      return this.getHydratedPrompt()
    },
    isViewShow () {
      return this.$route.query.action === VIEW
    },
    isViewEdit () {
      return this.$route.query.action === EDIT
    },
    isViewCreate () {
      const currentUrl = new URL(window.location)
      const paramValue = currentUrl.searchParams.get('action')
      return this.$route.query.action === CREATE || paramValue === CREATE
    },
    isNotValidateTitre () {
      return this.formSubmitted && this.localPromptData.titre === ''
    },
    isNotValidateTon () {
      return this.formSubmitted && this.localPromptData.ton === ''
    }
  },
  methods: {
    capitalizeFirstLetter,
          getHydratedPrompt () {
        const prompt = this.getPrompt
        // Normaliser la structure du prompt avant hydratation
        const normalizedPrompt = this.normalizePromptStructure(prompt)
        this.hydrateCheckedData(normalizedPrompt)
        return normalizedPrompt
      },
      /**
       * Normalise la structure du prompt pour garantir datum = { id, champs }
       * Gère les cas où le backend renvoie une structure imbriquée
       */
      normalizePromptStructure (prompt) {
        if (!prompt || !prompt.datum) {
          return prompt
        }

        // Si la structure est déjà correcte : { id, champs: [...] }
        if (prompt.datum.champs && Array.isArray(prompt.datum.champs)) {
          return prompt
        }

        // Si on a une structure imbriquée : { id, champs: { id, champs: [...], version } }
        if (prompt.datum.champs && prompt.datum.champs.champs && Array.isArray(prompt.datum.champs.champs)) {
          return {
            ...prompt,
            datum: {
              id: prompt.datum.id,
              champs: prompt.datum.champs.champs // Extraire le tableau des champs
            }
          }
        }

        return prompt
      },
    hydrateCheckedData (prompt) {
      this.isHydrating = true // Éviter de déclencher le watcher pendant l'hydratation
      
      if (prompt && prompt.datum && prompt.datum.champs) {
        this.checkedData = prompt.datum.champs.map(({ libelle }) => libelle)
        
      } else {
        // Réinitialiser checkedData si pas de données
        this.checkedData = []
      }
      
      this.$nextTick(() => {
        this.isHydrating = false // Réactiver la synchronisation après l'hydratation
      })
    },
    getPromptHydrated () {
      return {
        prompt: this.getHydratedPrompt(),
        checkedData: this.checkedData,
        isHydrated: true
      }
    },
    /**
     * Ajoute une donnée au prompt sans écraser l'objet datum
     */
    addDonneeToPrompt (donnee) {
      this.$store.commit('promptLibraries/addDonnee', donnee)
      // Synchroniser checkedData
      const libelle = donnee.libelle
      if (!this.checkedData.includes(libelle)) {
        this.checkedData.push(libelle)
      }
    },
    /**
     * Supprime une donnée du prompt sans écraser l'objet datum
     */
    removeDonneeFromPrompt (donneeId) {
      // Trouver la donnée dans le store pour récupérer son libellé
      const prompt = this.getPrompt
      if (prompt && prompt.datum && prompt.datum.champs) {
        const donnee = prompt.datum.champs.find(item => item.id === donneeId)
        if (donnee) {
          this.$store.commit('promptLibraries/removeDonnee', donneeId)
          // Synchroniser checkedData
          const index = this.checkedData.indexOf(donnee.libelle)
          if (index > -1) {
            this.checkedData.splice(index, 1)
          }
        }
      }
    },
    showListDataAnnonceur () {
      this.dialogDataVisible = true
    },
      previewResult () {
        // La synchronisation des données se fait automatiquement via le watcher
        // Il suffit de lancer la simulation
        this.$store.commit('promptLibraries/setMode', 'UBIFLOW_CUSTOM')
        this.$store.dispatch('promptLibraries/callSimulate')
      },
    confirmValidationPrompt () {
      this.formSubmitted = true
      this.promptActions()
    }
  },
  beforeMount () {
    this.$store.dispatch('promptLibraries/loadListDataInitialByJob')
  },
  mounted () {
    // Hydrater les données au montage si un prompt est déjà disponible
    if (this.getPrompt) {
      this.hydrateCheckedData(this.getPrompt)
    }
  },
  watch: {
    // Surveiller les changements du prompt pour réhydrater les données
    getPrompt: {
      handler (newPrompt) {
        if (newPrompt) {
          this.hydrateCheckedData(newPrompt)
        }
      },
      deep: true,
      immediate: true
    },
    // Surveiller les changements de checkedData pour synchroniser avec le store
    checkedData: {
      handler (newCheckedData) {
        // Ne synchroniser que si ce n'est pas pendant l'hydratation
        if (!this.isHydrating) {
          this.$store.commit('promptLibraries/setDonnees', newCheckedData)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.no-margin{
  margin-bottom: -20px !important;
}
.label-custom {
  margin-right: 5px!important;
  font-weight: bold;
}
.block {
  min-height: 1100px;
}
.error-donnees{
  color: #d24554;
  font-size: 12px;
}
.text-donnees{
  line-height: 1.5;
}
.container-donnees{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container-button-simulate{
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 15px;
}
.wait-simulateIA{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    text-align: center;
    width: 350px;
  }
}
</style>
